<!--
 * @Author: your name
 * @Date: 2022-02-19 17:44:19
 * @LastEditTime: 2022-04-05 23:17:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gshop-admin\src\views\product\spu\list.vue
-->
<template>
  <div class="excharts-container">
    <!-- <div class="excharts-header">
      <div class="header-list">
        <div class="img-container">图片</div>
        <div class="text-container">
          <div class="top">待寄出设备</div>
          <div class="bottom">
            <span>5</span>
            <span class="large">条</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="echarts-main">
      <div class="echarts-container">
        <div class="title-area">每月报修量</div>
        <div class="echarts-test" ref="echartsTest"></div>
      </div>
    </div>
    <div class="excharts-footer"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "",
  data() {
    return {
      option: {
        tooltip: {
          trigger: "axis",
        },
        legend:{ // 图列的配置
          bottom:'0%',
          left:'10%',
          data: ['Email', 'Union Ads', 'Video Ads', 'Direct']
        },
        grid: {//用来设置x y的宽高（距离canvas）
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],

          axisLabel: { 
            interval: 0,// 用来控制显示x轴显示的 刻度间隔，零表示每个都显示。
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "Email",
            type: "line",
            stack: "Total",
            data: [120, 132, 101, 134, 90, 230, 210, 110, 220, 55, 66, 77],
          },
          {
            name: "Union Ads",
            type: "line",
            stack: "Total",
            data: [
              220, 182, 191, 234, 290, 330, 310, 120, 132, 101, 134, 90, 230,
            ],
          },
          {
            name: "Video Ads",
            type: "line",
            stack: "Total",
            data: [150, 232, 201, 154, 190, 330, 410, 201, 154, 190, 330, 410],
          },
          {
            name: "Direct",
            type: "line",
            stack: "Total",
            data: [320, 332, 301, 334, 390, 330, 320, 201, 154, 190, 330, 410],
          },
        ],
      },
    };
  },
  mounted() {
    const myEchart = echarts.init(this.$refs.echartsTest);
    myEchart.setOption(this.option);
  },
};
</script>

<style lang="scss" scoped>
.excharts-container {
  width: 100%;
  height: auto;

  .header-list {
    width: 200px;
    height: 80px;
    background-color: aqua;
    padding: 0 8px;
    display: flex;
    border-radius: 5px;
    justify-content: space-between;
    align-items: center;
    .img-container {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 50%;
      background-color: white;
    }
    .text-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      .bottom {
        margin-top: 8px;
        .large {
          margin-left: 10px;
          font-size: 20px;
        }
      }
    }
  }
  .echarts-main {
    width: 49%;
    border: 0.005208rem solid #cccccc;
    border-radius: 10px;
    .echarts-container {
      width: 49%;
      height: auto;
      .title-area {
        width: 100%;
        height: 30px;
        border-bottom-style: 2px solid #999999;
      }
      .echarts-test {
        width: 400px;
        height: 400px;
      }
    }
  }
}
</style>
